import { Component, ViewChild } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Table, TableLazyLoadEvent } from 'primeng/table';
import {
  UserItem,
  AssetManagementMovementHistoryItem,
  AssetManagementItem,
  AssetManagementReplacementHistoryItem,
} from 'src/app/api/models';
import {
  AssetManagementService,
  GeoService,
  AgreementsService,
  RegistryOfficesService,
  IdentityService,
  ProductService,
} from 'src/app/api/services';
import { AuthService } from 'src/app/services/auth/auth.service';
import { MovementTypeEnum } from '../enums/movement_types_enum.enum';
import { DynamicDialogRef, DynamicDialogConfig, DialogService } from 'primeng/dynamicdialog';
import { BehaviorSubject, debounceTime, distinctUntilChanged, of, switchMap } from 'rxjs';
import { manipulateToUTCISOString } from 'src/main';
import { IdentityControllerGetAll$Params } from 'src/app/api/fn/identity/identity-controller-get-all';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';
import { AssetManagementControllerFindAllAssetManagementReplacementHistory$Params } from 'src/app/api/fn/asset-management/asset-management-controller-find-all-asset-management-replacement-history';

@Component({
  selector: 'app-modal-replacement-history',
  templateUrl: './modal-replacement-history.component.html',
  styleUrls: ['./modal-replacement-history.component.scss'],
})
export class ModalReplacementHistoryComponent {
  @ViewChild('dt2') table_replacement_history?: Table;

  protected readonly rowsPerPageOptions = [25, 50, 100, 200, 500];
  loading = false;
  asset_replacement_history: AssetManagementReplacementHistoryItem[] = [];
  totalRecordsReplacementsHistory: number = 0;
  selectedAsset?: AssetManagementItem;
  question_title: string;

  autocompleteUsers$ = new BehaviorSubject<string>('');
  suggestedUsers: UserItem[] = [];

  frmFilterReplacementHistory = new FormGroup({
    rangeDates: new FormControl<Date[] | undefined>(undefined),
    related_user: new FormControl<UserItem | undefined>(undefined),
  });

  constructor(
    public auth: AuthService,
    private assetMgmtService: AssetManagementService,
    private userService: IdentityService,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public dialogService: DialogService
  ) {
    this.question_title = config.data!.question_title;
    this.selectedAsset = config.data!.selectedAsset;
  }

  ngOnInit() {
    //attivo autocomplete users
    this.autocompleteUsers$
      .pipe(
        debounceTime(300),

        switchMap(query => {
          if (query) {
            let params: IdentityControllerGetAll$Params = {
              limit: 15,
              skip: 0,
              query: query,
            };
            return this.userService.identityControllerGetAll(params);
          } else {
            return of({
              data: { list: [] },
            });
          }
        })
      )
      .subscribe({
        next: res => {
          this.suggestedUsers = res.data.list.map(u => ({
            ...u,
            fullName: `${u.name} ${u.last_name}`,
          }));
        },
      });

    this.frmFilterReplacementHistory.valueChanges
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe(v => {
        this.loadAssetReplacementHistory(this.table_replacement_history?.createLazyLoadMetadata());
      });
  }

  filterUsers(event: AutoCompleteCompleteEvent) {
    let query = event.query;
    this.autocompleteUsers$.next(query);
  }

  loadAssetReplacementHistory(event: TableLazyLoadEvent) {
    this.loading = true;
    const frmValue = this.frmFilterReplacementHistory.value;
    const rangeDateFrom = frmValue.rangeDates
      ? manipulateToUTCISOString(frmValue.rangeDates[0], false)
      : undefined;
    const rangeDateTo = frmValue.rangeDates
      ? manipulateToUTCISOString(frmValue.rangeDates[1], true, true)
      : undefined;
    const params: AssetManagementControllerFindAllAssetManagementReplacementHistory$Params = {
      limit: +event.rows!,
      skip: +event.first!,
      related_user_id: frmValue.related_user ? frmValue.related_user.id : undefined,
      created_on_from: rangeDateFrom,
      created_on_to: rangeDateTo,
      id: this.selectedAsset?.id!,
    };
    this.assetMgmtService
      .assetManagementControllerFindAllAssetManagementReplacementHistory(params)
      .subscribe({
        next: res => {
          this.asset_replacement_history = res.data.list;
          this.totalRecordsReplacementsHistory = res.data.count;
          this.loading = false;
        },
      });
  }

  clearAssetReplacementHistory(table: Table, e: Event) {
    this.frmFilterReplacementHistory.reset();
  }
}
